import { render, staticRenderFns } from "./BpuList.vue?vue&type=template&id=e6145b52&scoped=true"
import script from "./BpuList.vue?vue&type=script&lang=js"
export * from "./BpuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6145b52",
  null
  
)

export default component.exports